import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { showModal } from '../../../actions/modal';
import moment from 'moment';
import { WAREHOUSE_TYPE_TRANSLATE } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .warehouse-type {
    font-size: 13px;
    font-weight: 700;
    font-size: 13px;
  }
  .warehouse-title {
    font-weight: 700;
    margin-bottom: 13px;
  }
  .header-title {
    margin-bottom: 14px;
  }
`;

const WarehouseBlock = (props) => {
  const { currentWarehouse, handleChange, currentSupply, isSupplyClosed = false } = props;

  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const handleOpenModal = () => {
    dispatch(
      showModal('SelectWarehouseSupplie', {
        handleChange,
        currentSupply,
        currentOrderCode: currentSupply.warehouseCode,
        warehouseCode: currentWarehouse ? currentWarehouse.warehouseCode : null,
        currentWarehouse: currentWarehouse,
      }),
    );
  };

  return (
    <Wrapper className={`card-box ${!currentWarehouse ? 'add-info' : ''}`}>
      <div style={{ display: 'flex' }}>
        <h4 className="header-title">{t('Склад')}</h4>
        {currentWarehouse ? (
          <div className="warehouse-type" style={{ marginLeft: 'auto' }}>
            <span className="help-tooltip-wrapper">
              {t(WAREHOUSE_TYPE_TRANSLATE[currentWarehouse.operatorType]) ||
                currentWarehouse.operatorType}
              {` `}
              {currentWarehouse.operatorType === `FULFILLMENT` ? (
                <>
                  {(() => {
                    if (currentSupply.warehouseFFExportError)
                      return (
                        <>
                          <i className="fe-alert-triangle" style={{ color: `#f1556c` }} />
                          <span className="help-tooltip">
                            {currentSupply.warehouseFFExportError &&
                              currentSupply.warehouseFFExportError}
                          </span>
                        </>
                      );
                    else if (currentSupply.warehouseFFSync)
                      return (
                        <>
                          <i className="fe-play-circle" style={{ color: `#1abc9c` }} />
                          <span className="help-tooltip">
                            {t('Поставка успешно выгружена в систему Фулфилмент')}:{` `}
                            {currentSupply.warehouseFFSyncDate &&
                              moment(currentSupply.warehouseFFSyncDate).format(
                                `DD.MM.YYYY hh:mm:ss`,
                              )}
                          </span>
                        </>
                      );
                    else if (!currentSupply.warehouseFFExported)
                      return (
                        <>
                          <i className="fe-pause-circle" style={{ color: `#98a6ad` }} />
                          <span className="help-tooltip">
                            {currentSupply.warehouseFFExportError &&
                              currentSupply.warehouseFFExportError}
                            {t('Поставка еще не выгружалась в систему Фулфилмент')}
                          </span>
                        </>
                      );
                    else return null;
                  })()}
                </>
              ) : null}
            </span>
          </div>
        ) : null}
      </div>
      {currentSupply?.warehouseName ? (
        <Fragment>
          <div className="border-top" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="block-subtitle">{t('Поставка на склад')}</div>
            <div className="change-link" style={{ marginLeft: 'auto' }} onClick={handleOpenModal}>
              {t('Изменить')}
            </div>
          </div>
          <div>
            <div className="warehouse-title">{currentSupply.warehouseName}</div>
            <div>{currentWarehouse?.address?.fullAddress}</div>
          </div>
        </Fragment>
      ) : (
        <div className="blocked-block">
          <div className="change-link" onClick={handleOpenModal}>
            {t('Добавить информацию')}
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default WarehouseBlock;
